<template>
  <div class="viewing-discipline">
    <page-header :title="nameDiscipline" />
    <!-- <h3 class="viewing-discipline__title">{{nameDiscipline}}</h3> -->
    <el-button-group>
      <el-button
        :size="mobileMode ? 'large' : ''"
        v-for="(item, index) of componentsList"
        :key="index"
        :class="{ tabActive: componentName === item.name }"
        type="primary"
        @click="componentName = item.name"
      >
        <i :class="item.icon"></i>
      </el-button>
    </el-button-group>
    <component
      @change="changeTab"
      :readOnly="false"
      v-bind:is="componentName"
    ></component>
  </div>
</template>

<script>
import viewingDisciplineTests from "../components/viewingDiscipline/viewingDisciplineTests";
import viewingDisciplineSections from "../components/viewingDiscipline/viewingDisciplineSections";
import viewingDisciplineVebinars from "../components/viewingDiscipline/viewingDisciplineVebinars";
import viewingDisciplineVideo from "../components/viewingDiscipline/viewingDisciplineVideo";
import viewingDisciplinePreview from "../components/viewingDiscipline/viewingDisciplinePreview";
import PageHeader from "../components/pageHeader.vue";
export default {
  name: "ViewingDiscipline",
  data() {
    return {
      componentName: "viewingDisciplineSections",
      componentsList: [
        {
          title: "Материалы",
          name: "viewingDisciplineSections",
          icon: "fas fa-folder",
        },
        // {
        //   title: "Видео",
        //   name:'viewingDisciplineVideo',
        //   icon: 'fas fa-film'
        // },
        // {
        //   title: "Вебинары",
        //   name:'viewingDisciplineVebinars',
        //   icon: 'fas fa-video'
        // },
        {
          title: "Тесты",
          name: "viewingDisciplineTests",
          icon: "fas fa-question",
        },
        {
          title: "Просмотр",
          name: "viewingDisciplinePreview",
          icon: "far fa-eye",
        },
      ],
    };
  },
  components: {
    viewingDisciplineSections,
    viewingDisciplineVebinars,
    viewingDisciplineVideo,
    viewingDisciplineTests,
    viewingDisciplinePreview,
    "page-header": PageHeader,
  },
  computed: {
    nameDiscipline() {
      return this.$store.state.viewingDiscipline.treeData.lable;
    },
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },
  methods: {
    changeTab(data) {
      this.componentName = data.tab;
    },
  },

  beforeDestroy() {
    this.$store.state.viewingDiscipline.selectedItem = null;
  },
};
</script>

<style lang="scss">
.viewing-discipline {
  height: 100%;
  display: grid;
  grid-template-rows: 50px 50px 1fr;
  row-gap: 10px;
  .page-header {
    margin-bottom: 0;
  }
  .tabActive {
    background-color: $basic-white;
    color: $brand-clr-1;
    &:focus {
      background-color: $basic-white;
      color: $brand-clr-1;
    }
  }
  .el-button-group {
    justify-self: left;
    align-self: center;
    width: max-content;
    height: max-content;
  }
}
@media (max-width: 800px) {
  .viewing-discipline {
    .el-button-group {
      justify-self: center;
    }
  }
}
</style>